// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null,
  statistics: null,
  trending: []
}

const clinicalDocument = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_CLINICAL_DOCUMENT':
      return {
        ...state,
        data: action.data,
        total: action.total,
        params: action.params,
        from: action.from,
        to: action.to
      }
    case 'GET_CLINICAL_DOCUMENT':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_CLINICAL_DOCUMENT':
      return { ...state }
    case 'UPDATE_CLINICAL_DOCUMENT':
      return { ...state }
    case 'DELETE_CLINICAL_DOCUMENT':
      return { ...state }
    case 'GET_CLINICAL_STATISTICS':
      return { ...state, statistics: action.statistics }
    case 'GET_CLINICAL_TRENDING':
      return { ...state, trending: action.trending }
    default:
      return { ...state }
  }
}

export default clinicalDocument
